// extracted by mini-css-extract-plugin
export var addButton = "_dt-4";
export var contentBlockImage = "_dt-i";
export var contentBlockWidgetPreview = "_dt-g";
export var fulfillmentCutoffWidgetPreview = "_dt-9";
export var imageBackdrop = "_dt-6";
export var imageIcon = "_dt-8";
export var lowProfileImageContainer = "_dt-b";
export var lowProfileImageIcon = "_dt-f";
export var lowProfileImageIconContainer = "_dt-e";
export var lowProfileImagePlaceholder = "_dt-d";
export var lowProfileProductImage = "_dt-c";
export var lowProfileProductUpsellWidgetPreview = "_dt-a";
export var productCard = "_dt-5";
export var productImage = "_dt-7";
export var productReviewsWidgetPreview = "_dt-h";
export var progressBar = "_dt-1";
export var progressBarFill = "_dt-2";
export var progressBarTrack = "_dt-3";
export var shippingOptionWidgetPreview = "_dt-j";
export var shippingUpsellProgressBar = "_dt-k";
export var thresholdUpsellWidgetPreview = "_dt-0";